import { createSlice } from "@reduxjs/toolkit"

export interface ProjectMs {
  minorityBusiness: string
  womanOwned: string
  smallBusiness: string
  localHiring: string
  cleanSlateHires: string
  safeFoundationHires: string
  davisBacon?: string
  minoritySetAside?: string
}

const initialState: ProjectMs = {
  minorityBusiness: "",
  womanOwned: "",
  smallBusiness: "",
  localHiring: "",
  cleanSlateHires: "",
  safeFoundationHires: "",
  davisBacon: 'No',
  minoritySetAside: 'No'
}

export const ProjectMsSlice = createSlice({
  name: 'projectMs',
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload
      }
    }
  }
})

export const { set } = ProjectMsSlice.actions

export default ProjectMsSlice.reducer
